import React, { useCallback } from 'react';
import { UseMultiSchoolSelect } from 'types';
import Carousel from 'components/sections/carousel/Carousel';
import { SelectionCardAlt } from 'components/form-wizards/micro-portal/SelectionCard/SelectionCardAlt';
import { NOP } from 'utils/generalUtils';

interface Props {
  state: UseMultiSchoolSelect['state'];
  handleSyncCarouselIndex: (index: number) => void;
}

export default function MultiSchoolSelectList({
  state,
  handleSyncCarouselIndex,
}: Props): React.JSX.Element {
  // Find if any school is currently expanded
  const foundIndex = Object.values(state).findIndex(
    (school) => school.isExpanded
  );

  let expandedIndex = foundIndex;
  if (foundIndex === -1) {
    // Check if all schools have been either submitted or skipped
    // Only proceed if there are actually schools to check
    const schools = Object.values(state);
    const allSchoolsHandled =
      schools.length > 0 &&
      schools.every((school) => school.isSubmitted || school.isSkipped);
    // Default to first slide (0) only if all schools are handled
    expandedIndex = allSchoolsHandled ? 0 : -1;
  }

  // Handle carousel index changes (from swipes, navigation, etc.)
  const handleCarouselIndexChange = useCallback(
    (newIndex: number) => {
      handleSyncCarouselIndex(newIndex);
    },
    [handleSyncCarouselIndex]
  );

  return (
    <div className="multiSchoolSelectList">
      <Carousel
        currentIndex={expandedIndex}
        showNav={false}
        variant="coverFlow"
        scrollToActiveSlide={false}
        onSlideAnimationStart={handleCarouselIndexChange}
        onCarouselIndexChangeAttempt={NOP}
      >
        {Object.values(state).map((school, index) => (
          <SelectionCardAlt
            key={school.schoolInfo.id}
            id={school.schoolInfo.id}
            index={index}
          />
        ))}
      </Carousel>
    </div>
  );
}
